/** Staff (employee) work tabs embedded under /operations as ?tab=staff-* */

export const EMPLOYEE_WORK_TABS = [
  'import',
  'post',
  'moderation',
  'culture',
  'community',
  'radar',
  'lab',
  'heart',
  'grow',
  'pages',
  'activity',
] as const;

export type EmployeeWorkTab = (typeof EMPLOYEE_WORK_TABS)[number];

const SET = new Set<string>(EMPLOYEE_WORK_TABS);

export function isEmployeeWorkTab(s: string): s is EmployeeWorkTab {
  return SET.has(s);
}

export function staffNavKey(work: EmployeeWorkTab): `staff-${EmployeeWorkTab}` {
  return `staff-${work}`;
}

export function parseStaffNavKey(tab: string): EmployeeWorkTab | null {
  if (!tab.startsWith('staff-')) return null;
  const rest = tab.slice(6);
  return isEmployeeWorkTab(rest) ? rest : null;
}
